import styled from "styled-components";

export const PageContainer = styled.div<{ $isTransitioning: boolean }>`
  opacity: ${({ $isTransitioning }) => ($isTransitioning ? 0.5 : 1)};
  transition: opacity 0.3s ease-in-out;
`;

export const PageHeader = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const ErrorBoundaryContainer = styled.div`
  padding: 20px;
  margin: 20px;
  border: 1px solid ${({ theme }) => theme.colors.error};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
`;
